import { Card, Flex, Text, Divider, Button } from "@theorgchartdev/storybook";
import cx from "classnames";

/**
 * @param {*} props
 * @returns ReactNode
 */
const SectionCard = ({
  title,
  titleContent,
  description,
  help,
  maxHeight,
  customStyle,
  customSectionCardClass,
  children,
  flexProps,
  childWrapperClass,
  headerFlexProps,
  customCardStyle,
  titleContainerProps
}) => {
  return (
    <div
      style={{ maxHeight: maxHeight, ...customStyle }}
      className={cx("ocn-section-card", "ocn-list-scrollbar", customSectionCardClass)}
    >
      <Card className={"oc-fill-height"} style={customCardStyle}>
        <Flex gap={"8px"} direction={"column"} height={"100%"} {...flexProps}>
          {(title || description || titleContent) && (
            <Flex direction={"column"} gap={"4px"}>
              <Flex
                gap={"4px"}
                alignItems={"center"}
                padding={"0 8px 0 4px"}
                height={"48px"}
                justifyContent={"space-between"}
                {...headerFlexProps}
              >
                <Flex gap={"4px"} alignItems={"center"}>
                  {description && (
                    <Button
                      tooltipProps={{ message: description, position: "top-start" }}
                      modifier={"tertiary"}
                      iconOnly={true}
                      size="small"
                      iconProps={{ name: "circle-info" }}
                    />
                  )}
                  {title && (
                    <Text
                      style={{ fontSize: "18px", fontWeight: 400, marginBottom: 0 }}
                      type={"display"}
                      modifier={"medium"}
                      element={"h2"}
                      {...titleContainerProps}
                    >
                      {title}
                    </Text>
                  )}
                  <div>
                    {help && (
                      <Button
                        tooltipProps={{ message: description }}
                        modifier={"tertiary"}
                        iconOnly={true}
                        iconProps={{ name: "circle-question" }}
                      />
                    )}
                  </div>
                </Flex>
                {titleContent}
              </Flex>
              <Divider vertical={false} />
            </Flex>
          )}
          <div style={{ padding: "4px", height: "100%", ...childWrapperClass }}>{children}</div>
        </Flex>
      </Card>
    </div>
  );
};

export const SectionCardGroup = ({
  children,
  customClass = "",
  customStyle = {},
  addMarginAbove = true,
  addMarginBelow = true,
  flexProps = {}
}) => {
  return (
    <Flex
      direction={"column"}
      gap={"32px"}
      className={cx(
        "ocn-section-card-group",
        addMarginAbove ? "ocn-section-card-group--marginTop" : null,
        addMarginBelow ? "ocn-section-card-group--marginBottom" : null,
        customClass
      )}
      style={customStyle}
      {...flexProps}
    >
      {children}
    </Flex>
  );
};

export const SectionCardGroupHorizontal = props => {
  const flexProps = { direction: "row", width: "100%", height: "400px", gap: "20px" };
  return <SectionCardGroup flexProps={flexProps} {...props} />;
};

export const SectionCardHorizontal = props => {
  const cardWidth = props.cardCount != null ? 100 / props.cardCount : 100;
  const cardStyle = {
    width: `${cardWidth}%`,
    maxWidth: `${cardWidth}%`,
    maxHeight: "400px",
    flex: "1",
    overflow: "hidden"
  };
  const childWrapperClass = {
    flex: "1",
    height: "auto",
    overflow: "hidden"
  };
  return <SectionCard customStyle={cardStyle} childWrapperClass={childWrapperClass} {...props} />;
};

export const SectionCardControls = props => {
  return (
    <SectionCard {...props}>
      <Flex gap={"12px"} direction={"row"}>
        {props.children}
      </Flex>
    </SectionCard>
  );
};

export default SectionCard;
